import { FC } from "react";
import { Tooltip } from "antd";
import { ReactComponent as PointerIcon } from "../../../../assets/icons/svg/pointer.svg";
import { SvgIcon } from "../../../../common/components/SvgIcon";
import { SupplyAndDemand as SupplyAndDemandType } from "../../../../types/IntelligenceTypes";
import { GenericCard } from "../../../../common/components/GenericCard";
import styles from "./SupplyAndDemand.module.less";

function getPointerClass(type?: string) {
    switch (type) {
        case "buyer":
            return styles.pointerBuyer;
        case "seller":
            return styles.pointerSeller;
        default:
            return "";
    }
}

interface SupplyAndDemandProps {
    data?: SupplyAndDemandType;
}

export const SupplyAndDemand: FC<SupplyAndDemandProps> = ({ data }) => {
    const pointerTypeClass = getPointerClass(data?.marketType);
    const pointerClass = `${styles.pointer} ${pointerTypeClass}`;
    const points = data?.comparison.concat(data?.recentChanges);

    return (
        <GenericCard size="larger" className={styles.card}>
            <div className={styles.content}>
                <div className={styles.titleRow}>
                    <div className={styles.title}>Supply and demand conditions</div>
                    <Tooltip title="This metric provides an overview of the current supply and demand conditions in vendor's market. Understanding these conditions is essential for making informed decisions about pricing, production, and inventory management.">
                        <SvgIcon name="help" size={12} color="#1890FF" />
                    </Tooltip>
                </div>
                <div className={styles.contentMain}>
                    <div className={styles.chart}>
                        <div className={styles.gaugeContainer}>
                            <div className={styles.gauge}>
                                <div className={pointerClass}>
                                    <PointerIcon />
                                </div>
                            </div>
                            <div className={styles.labels}>
                                <div className={styles.buyer}>Buyer</div>
                                <div className={styles.supplier}>Supplier</div>
                            </div>
                        </div>
                    </div>
                </div>
                <ul className={styles.points}>{points?.map((p) => <li key={p}>{p}</li>)}</ul>
            </div>
        </GenericCard>
    );
};
